export default __webpack_public_path__ + "static/media/HP1.0586713c.jpg";